module.exports = __webpack_public_path__ + "static/media/grayscale.c9e0932d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DivisionNavbarItem/images/grayscale.svg
// module id = 1060
// module chunks = 0